/**
 * @generated SignedSource<<7b83c7d474abc169a5fedd5681d45265>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksArticlePageTypeformConfigArticle$data = {
  readonly typeformConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "hooksArticlePageTypeformConfigArticle";
};
export type hooksArticlePageTypeformConfigArticle$key = {
  readonly " $data"?: hooksArticlePageTypeformConfigArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksArticlePageTypeformConfigArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksArticlePageTypeformConfigArticle",
  "selections": [
    {
      "alias": "typeformConfig",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "poll_typeform"
          }
        }
      ],
      "concreteType": "AppConfigs",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "json",
          "storageKey": null
        }
      ],
      "storageKey": "appConfig(filter:{\"entityId\":\"poll_typeform\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "36c89d51a328fb715c1810c203c593da";

export default node;
